import styled from 'styled-components'

const StyledPayouts = styled.div`
  .payout-metrics {
    grid-gap: 20px;
    display: grid;

    .skeleton-item {
      height: 158px;
      padding: 0;
    }

    .payout-metric {
      background-color: ${({ theme }) => theme.colors.green[50]};
      color: ${({ theme }) => theme.colors.green[600]};
      font-family: ${({ theme }) => theme.fonts.lexend};
      border-radius: 6px;
      padding-bottom: 20px;

      .payout-value {
        font-size: 32px;
        font-weight: 300;
        margin: 20px;
        display: block;
      }

      .payout-details {
        font-size: 14px;
        font-weight: 400;

        .payout-main-date,
        .payout-earnings-date {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 20px;
        }

        .payout-earnings-date {
          color: ${({ theme }) => theme.colors.green[600]}b0;
        }

        hr {
          margin: 14px 0;
          background-color: ${({ theme }) => theme.colors.green[100]};
        }
      }

      &:not(:first-child) {
        background-color: ${({ theme }) => theme.colors.gray[50]};

        .payout-value {
          color: ${({ theme }) => theme.colors.gray[700]};
        }

        .payout-details {
          .payout-main-date {
            color: ${({ theme }) => theme.colors.gray[700]};
          }

          .payout-earnings-date {
            color: ${({ theme }) => theme.colors.gray[500]};
          }

          hr {
            background-color: ${({ theme }) => theme.colors.gray[200]};
          }
        }
      }
    }
  }

  .total-earnings {
    display: grid;
    justify-content: center;
    place-items: center;
    width: 100%;

    .earnings-label {
      font-size: 14px;
      color: ${({ theme }) => theme.colors.gray[500]};
      font-weight: 600;
      text-align: center;
    }

    .earnings-value {
      font-size: 32px;
      font-weight: 300;
      text-align: center;
      margin-top: 12px;
      font-family: ${({ theme }) => theme.fonts.lexend};
      color: ${({ theme }) => theme.colors.gray[700]};
    }

    .paypal-btn {
      width: 100%;
      margin-top: 25px;
      border-radius: 50rem;
      background-color: #0070ba;

      &:hover {
        background-color: #003087;
      }
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.s}px) {
    .payout-metrics {
      grid-template-columns: 1fr 1fr;
    }
  }
`

export default StyledPayouts
